export default {
      id: "icon-crumbs-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-crumbs",
      toString: function () {
        return this.url;
      }
    }